import { useClosingOrdersStore } from '@ui/features/Websocket/useClosingOrdersStore';
import { useClosingTradesStore } from '@ui/features/Websocket/useClosingTradesStore';
import { usePendingLimitOrdersStore } from '@ui/features/Websocket/usePendingLimitOrdersStore';
import { usePendingTradesStore } from '@ui/features/Websocket/usePendingTradesStore';
import { POSTHOG_EVENTS, resetPostHog, trackEvent } from '@ui/lib/posthog';
import { useCallback } from 'react';
import { useDisconnect } from 'wagmi';

export const useDisconnectWallet = () => {
  const { disconnect, connectors } = useDisconnect();

  return useCallback(() => {
    // clear transient data for all chains
    // clear transient data for all chains via reset helpers
    usePendingTradesStore.getState().resetPendingTrades();
    useClosingTradesStore.getState().resetClosingTrades();
    usePendingLimitOrdersStore.getState().resetPendingLimitOrders();
    useClosingOrdersStore.getState().resetClosingOrders();

    const h = async () => {
      try {
      } catch {}

      // Also reset wagmi connectors state (injected, mock, etc.)
      connectors.forEach((c) => {
        disconnect({ connector: c });
      });
      trackEvent(POSTHOG_EVENTS.disconnectWallet);
      resetPostHog();
    };
    h();
  }, [connectors, disconnect]);
};
